import axios from "../../../axios/index.js"
import store from "../../../../store/store.js"

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []
let domain = store.state.domain;

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber(callback) {
  subscribers.push(callback)
}

export default {
  init() {
    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config

      // if (status === 401) {
      if (response && response.status === 401) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true
          store.dispatch("auth/fetchAccessToken")
            .then((access_token) => {
              isAlreadyFetchingAccessToken = false
              onAccessTokenFetched(access_token)
            })
        }

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber(access_token => {
            originalRequest.headers.Authorization = 'Bearer ' + access_token
            resolve(axios(originalRequest))
          })
        })
        return retryOriginalRequest
      }
      return Promise.reject(error)
    })
  },
  login(email, pwd) {
    return  axios.post(domain+`mapgrafi/seguridad/login`, {email: email, contrasenia: pwd,cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,cod_empresa_aca:process.env.VUE_APP_COD_EMPRESA_ACADEMICO});
  },
  registerUser(detalle) {
    return axios.post(domain+`mapgrafi/seguridad/usuario-insertar-actualizar`, 
    {
      evento               : "I",
      cod_empresa          : null,
      contrasenia          : detalle.contrasenia,
      nombres              : detalle.nombres,
      apellidos            : detalle.apellidos,
      numero_identificacion: detalle.numero_identificacion,
      email                : detalle.email,
      telefono             : detalle.telefono,
      celular              : detalle.celular == null ? '' : detalle.celular,
      cod_persona          : detalle.cod_persona,
      direccion            : detalle.direccion,
      referencia           : detalle.referencia,
      pais                 : detalle.pais,
      provincia            : detalle.provincia,
      canton               : detalle.canton,
      parroquia            : detalle.parroquia,
      id_pais              : detalle.id_pais,
      id_provincia         : detalle.id_provincia,
      id_canton            : detalle.id_canton,
      id_parroquia         : detalle.id_parroquia,
      cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
      cod_empresa_aca:process.env.VUE_APP_COD_EMPRESA_ACADEMICO
    });
  },
  recoverUserJWT(detalle) {
    return axios.post(domain+`mapgrafi/seguridad/usuario-recuperar-email`, 
    {
      evento               : "R",
      cod_empresa          : null,
      email                : detalle.email,
      cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
      cod_empresa_aca:process.env.VUE_APP_COD_EMPRESA_ACADEMICO
    });
  },
  recoverUserConfirmJWT(detalle) {
    return axios.post(domain+`mapgrafi/seguridad/usuario-confirmacion-recuperacion-email`,{
      hash                : detalle.hash,
      contrasenia         : detalle.contrasenia,
      cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
      cod_empresa_aca:process.env.VUE_APP_COD_EMPRESA_ACADEMICO
    });
  },
  refreshToken() {
    return axios.post("/api/auth/refresh-token", {accessToken: localStorage.getItem("accessToKen")})
  },
  insertaActualizaElimina(evento,id_usuario,carrito) {
    return axios.post(domain+`mapgrafi/mapgrafi-general/inserta-actualiza-elimina-carrito`, 
    {
      evento             : evento,
      id_usuario         : id_usuario,
      carrito            : carrito,
      cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
      cod_empresa_aca:process.env.VUE_APP_COD_EMPRESA_ACADEMICO
    });
  },
  listarCarrito(id_usuario) {
    return axios.get(domain+`mapgrafi/mapgrafi-general/listar-carrito/${id_usuario}/${process.env.VUE_APP_COD_EMPRESA_ERP}`);
  },
  /** validacion hash - cambio de contraseña */
  verificarHash(payload){
    return axios.post(`${domain}mapgrafi/seguridad/usuario-valida-hash-email`,payload);
  }
}